import IApiResponse from "../interfaces/IApiResponse";
import IPrayerSettings from "../interfaces/IPrayerSettings";
import PrayerSettingsServiceHybrid from "./hybrid/PrayerSettingsServiceHybrid";
import PrayerSettingsServiceWeb from "./web/PrayerSettingsServiceWeb";
import { isPlatform } from "@ionic/react";

export interface IPrayerSettingsService {
    createPrayerSettings: (prayerSettings: IPrayerSettings) => Promise<IApiResponse<IPrayerSettings>>,
    getPrayerSettings: () =>  Promise<IApiResponse<IPrayerSettings>>,
    updatePrayerSettings: (prayerSettings: IPrayerSettings) => Promise<IApiResponse<IPrayerSettings>>,
}

const PrayerSettingsService: IPrayerSettingsService = {
    
    createPrayerSettings: (prayerSettings) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - PrayerSettingsService')
            return PrayerSettingsServiceHybrid.createPrayerSettings(prayerSettings);
        } else {
            console.log('WEB - PrayerSettingsService')
            return PrayerSettingsServiceWeb.createPrayerSettings(prayerSettings);
        }
    },
    getPrayerSettings: () =>  {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - PrayerSettingsService')
            return PrayerSettingsServiceHybrid.getPrayerSettings();
        } else {
            console.log('WEB - PrayerSettingsService')
            return PrayerSettingsServiceWeb.getPrayerSettings();
        }
    },
    updatePrayerSettings: (prayerSettings) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - PrayerSettingsService')
            return PrayerSettingsServiceHybrid.updatePrayerSettings(prayerSettings);
        } else {
            console.log('WEB - PrayerSettingsService')
            return PrayerSettingsServiceWeb.updatePrayerSettings(prayerSettings);
        }
    },
}

export default PrayerSettingsService;